<template>
  <div>
    <Table border :columns="columns5" :data="data5" :span-method="handleSpan">
      <template slot-scope="{ row, index }" slot="criterionType">
        <div>
          <div style="margin-top: 10px">
            {{ lang == "zh" ? row.criterionType : row.enCriterionType }}
          </div>
          <div
            v-html="
              lang == 'zh' ? row.activesPerformed : row.enActivesPerformed
            "
          ></div>
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="expectDetails">
        <Input
          type="textarea"
          v-model="row.expectDetails"
          v-if="
            !(
              (applyEditFlag == '1' || userDeptFlag != '1') &&
              targetRevisionState
            )
          "
          :autosize="{
            minRows: [
              'goalSetting',
              'midTermReview',
              'yearEndSummary',
            ].includes(tabName)
              ? 30
              : 3,
          }"
          :disabled="
            (applyEditFlag == '1' || userDeptFlag != '1') && targetRevisionState
          "
          @on-change="targetItemChange(row, index, 'expectDetails')"
        />
        <span class="textareaCell" v-else>{{ row.expectDetails }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="empDetails">
        <Input
          type="textarea"
          v-model="row.empDetails"
          v-if="!(applyEditFlag == '1' || userDeptFlag != '1')"
          :autosize="{
            minRows: [
              'goalSetting',
              'midTermReview',
              'yearEndSummary',
            ].includes(tabName)
              ? 30
              : 3,
          }"
          :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
          @on-change="targetItemChange(row, index, 'empDetails')"
        />
        <span class="textareaCell" v-else>{{ row.empDetails }}</span>
      </template>
      <!-- <template slot-scope="{ row,index }" slot="empDetails">
                  <Input type="textarea" v-model="row.empDetails" :autosize="{minRows: 3}" :disabled="applyEditFlag=='1'" @on-change="targetItemChange(row,index,'empDetails')"/>
              </template> -->
      <template slot-scope="{ row, index }" slot="indirSupFeedback">
        <Input
          type="textarea"
          v-model="row.indirSupFeedback"
          v-if="
            !(
              applyEditFlag == '1' ||
              (userDeptFlag != '3' && userDeptFlag != '4')
            )
          "
          :autosize="{
            minRows: [
              'goalSetting',
              'midTermReview',
              'yearEndSummary',
            ].includes(tabName)
              ? 30
              : 3,
          }"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '3' && userDeptFlag != '4')
          "
          @on-change="targetItemChange(row, index, 'indirSupFeedback')"
        />
        <span class="textareaCell" v-else>{{ row.indirSupFeedback }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="dirSupFeedback">
        <Input
          type="textarea"
          v-model="row.dirSupFeedback"
          v-if="
            !(
              applyEditFlag == '1' ||
              (userDeptFlag != '2' && userDeptFlag != '4')
            )
          "
          :autosize="{
            minRows: [
              'goalSetting',
              'midTermReview',
              'yearEndSummary',
            ].includes(tabName)
              ? 30
              : 3,
          }"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '2' && userDeptFlag != '4')
          "
          @on-change="targetItemChange(row, index, 'dirSupFeedback')"
        />
        <span class="textareaCell" v-else>{{ row.dirSupFeedback }}</span>
      </template>
      <template slot-scope="{ row }" slot="status">
        <span style="color: red" v-if="row.status == '新增'"
          ><!-- 新增 -->{{ $t("Add") }}</span
        >
        <!-- <span style="color:red" v-if="row.status=='删除'">删除{{$t('Delete')}}</span> -->
        <span style="color: red" v-if="row.status == '编辑'"
          ><!-- 编辑 -->{{ $t("Edit") }}</span
        >
      </template>
    </Table>
  </div>
</template>
  
  <script>
import columns from "./columns.js";
export default {
  props: ["tabName"],
  data() {
    return {
      columns5: [],
      status: "",
      applyEditFlag: "",
      userDeptFlag: "",
      data5: [
        {
          criterionType: "我们永怀炽热之心，不断追求卓越表现",
          enCriterionType:
            "We live by Semper Ardens and constantly strive for the extraordinary",
          activesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left">不止于: 以诚信推动业绩，以激情实现我们的（短期）承诺 <br /> 更需要: 挑战当下，满怀雄心，树立远大目标，不断创新，以领先于时代</div>',
          enActivesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left">Beyond: We drive performance and passionately deliver on our (short-term) commitments with integrity <br />To: We challenge status quo, set stretched ambitions, and innovate to build beyond our time </div>',
          expectDetails: "",
        },
        {
          criterionType: "我们营造一个充满正能量、具有同理心的工作环境",
          enCriterionType:
            "We foster an environment of positive energy and compassion ",
          activesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">不止于: 关注合作，努力工作以完成任务 <br /> 更需要: 践行同理心、平等和包容，拥抱思想多样性，并共同庆祝成功 </div>',
          enActivesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">Beyond: We focus on collaboration and working hard to get things done <br /> To: We practice compassion, equity, and inclusion, embrace diversity of thought, and celebrate success </div>',
          expectDetails: "",
        },
        {
          criterionType: "我们所做的一切始终以消费者为中心",
          enCriterionType:
            "We are passionate about the consumer in everything we do ",
          activesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">不止于: 深深自豪于啤酒和品牌管理方面获得的良好财务表现和拥有的丰富经验<br /> 更需要: 成为充满激情的品牌大使，在我们所做的一切中为消费者创造价值</div>',
          enActivesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">Beyond: We have deep pride and experience in beer and managing our brands for sound financial performance  <br /> To: We act as passionate brand ambassadors creating value for consumers in all we do </div>',
          expectDetails: "",
        },
        {
          criterionType: "我们快速决策，卓越交付",
          enCriterionType: "We decide fast and deliver with excellence ",
          activesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">不止于: 以数据为依据，以事实为基础进行决策，并严格执行<br /> 更需要: 建立信任，从失败中吸取教训，推动创新，赋能和授权员工，优先追求速度而非完美 </div>',
          enActivesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">Beyond: We make data-driven, fact-based decisions and execute with rigour <br /> To: We build trust to learn from failures and drive innovation, empower people, and prioritise speed over perfection </div>',
          expectDetails: "",
        },
        {
          criterionType:
            "我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力",
          enCriterionType:
            "We empower, support, and grow our people to reach their full potential ",
          activesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">不止于:拥有充满激情和敬业精神的员工队伍，他们的工作热情和职业道德令人钦佩<br /> 更需要: 投资于员工的成长，创造相互学习、成长和实践的机会 </div>',
          enActivesPerformed:
            '<div style="margin:20px 10px;float:left;text-align:left"">Beyond: We have a driven and committed employee base admired for their passion and work ethic <br /> To: We invest in growing our people and creating mutual opportunities to learn, grow, and deliver </div>',
          expectDetails: "",
        },
      ],
      targetRevisionState: true,
      oldData: [],
    };
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (this.tabName == "midTermReview" || this.tabName == "yearEndSummary") {
        if (this.tabName == "yearEndSummary") {
          if (this.userDeptFlag == "1") {
            if (this.status < 5) {
              this.columns5 = this.midBehaviorColumns.filter(function (e) {
                return !e.hidden;
              });
            } else {
              this.columns5 = this.midBehaviorColumns;
            }
          } else {
            this.columns5 = this.midBehaviorColumns;
          }
        } else if (this.tabName == "midTermReview") {
          this.columns5 = this.midBehaviorColumns;
        } else {
          this.columns5 = this.goalBehaviorColumns;
        }
      } else {
        this.columns5 = this.goalBehaviorColumns;
        this.$emit("onInter");
      }
    },
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    goalBehaviorColumns() {
      return [
        {
          title: /* "增长文化" */ this.$t("GrowthCulture"),
          key: this.lang == "zh" ? "criterionType" : "enCriterionType",
          minWidth: 100,
          ellipsis: false,
        },
        {
          title: " ",
          key: this.lang == "zh" ? "activesPerformed" : "enActivesPerformed",
          align: "center",
          type: "html",

          minWidth: 200,
        },
        // {
        //   title: /* "增长文化" */ this.$t("GrowthCulture"),
        //   key: this.lang == "zh" ? "criterionType" : "enCriterionType",
        //   minWidth: 100,
        //   ellipsis: false,
        // },
        // {
        //   title: /* "行为标准" */ this.$t("Attributes"),
        //   key: this.lang == "zh" ? "activesPerformed" : "enActivesPerformed",
        //   align: "center",
        //   type: "html",

        //   minWidth: 200,
        // },
        {
          title:
            /* "达成目标过程中的行为期望（可参考直线经理或其他相关方对您的反馈）" */ this.$t(
              "longText27"
            ),
          slot: "expectDetails",
          align: "center",
          minWidth: 260,
          ellipsis: true,
        },
      ];
    },
    midBehaviorColumns() {
      return [
        {
          title: /* "3A准则" */ this.$t("GrowthCulture"),
          key: this.lang == "zh" ? "criterionType" : "enCriterionType",
          align: "center",
          minWidth: 200,
          ellipsis: false,
        },
        {
          title: /* "行为标准" */ " ",
          key: this.lang == "zh" ? "activesPerformed" : "enActivesPerformed",
          align: "center",
          type: "html",

          minWidth: 300,
        },
        {
          title:
            /* "达成目标过程中的行为期望（可参考直线经理或其他相关方对您的反馈）" */ this.$t(
              "longText27"
            ),
          slot: "expectDetails",
          align: "center",
          minWidth: 260,
          ellipsis: true,
        },
        {
          title: /* "员工说明" */ this.$t("Employee_Comment"),
          slot: "empDetails",
          align: "center",
          minWidth: 300,
          ellipsis: true,
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 虚线上级反馈 */,
          slot: "indirSupFeedback",
          align: "center",
          minWidth: 250,
          ellipsis: true,
          hidden: true,
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          slot: "dirSupFeedback",
          align: "center",
          minWidth: 250,
          ellipsis: true,
          hidden: true,
        },
      ];
    },
  },
  created() {
    if (this.tabName == "midTermReview" || this.tabName == "yearEndSummary") {
      this.getMidData();
    } else {
      this.columns5 = this.goalBehaviorColumns;
    }
  },
  methods: {
    handleSpan({ row, column, rowIndex, columnIndex }) {
      // 目标设定
      if (this.tabName == "goalSetting") {
        if ([0].includes(rowIndex) && columnIndex === 2) {
          return {
            rowspan: 5,
            colspan: 1,
          };
        }
        if ([1, 2, 3, 4].includes(rowIndex) && columnIndex === 2) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      // 阶段回顾 年终评估
      if (["midTermReview", "yearEndSummary"].includes(this.tabName)) {
        // 具体行为期望（如有）、员工自评、虚线上级反馈、直线上级反馈
        if ([0].includes(rowIndex) && [2, 3, 4, 5].includes(columnIndex)) {
          return {
            rowspan: 5,
            colspan: 1,
          };
        }
        // 具体行为期望（如有）、员工自评、虚线上级反馈、直线上级反馈
        if (
          [1, 2, 3, 4].includes(rowIndex) &&
          [2, 3, 4, 5].includes(columnIndex)
        ) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    getMidData() {
      if (this.tabName == "yearEndSummary") {
        if (this.userDeptFlag == "1") {
          if (this.status < 5) {
            this.columns5 = this.midBehaviorColumns.filter(function (e) {
              return !e.hidden;
            });
          } else {
            this.columns5 = this.midBehaviorColumns;
          }
        } else {
          this.columns5 = this.midBehaviorColumns;
        }
      } else if (this.tabName == "midTermReview") {
        this.columns5 = this.midBehaviorColumns;
      } else {
        this.columns5 = this.goalBehaviorColumns;
      }
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.data5[index], key, row[`${key}`]);
      if (
        JSON.stringify(this.oldData[index]) !=
          JSON.stringify(this.data5[index]) &&
        !this.targetRevisionState
      ) {
        if (row.status != "新增") {
          /* && row.status!='删除' */
          this.$set(this.data5[index], "status", "编辑");
          this.$set(this.oldData[index], "status", "编辑");
        }
      } else if (!this.targetRevisionState) {
        this.$set(this.data5[index], "status", "");
        this.$set(this.oldData[index], "status", "");
      }
    },
  },
};
</script>
<style scoped>
.textareaCell {
  padding-left: 18px;
  padding-right: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/GrowthCulture.vue